import { connect } from 'react-redux';
import type { Props } from '@/pages/CompanyReport/components/Dividend';
import Dividend from '@/pages/CompanyReport/components/Dividend';
import { getDividendSectionSelector } from '@/pages/CompanyReport/components/Dividend/redux/selectors';
import { getViewMode } from '@/redux/location/selectors';
import { areStatesEqualCompanySection } from '@/pages/CompanyReport/redux/selectors';

const mapStateToProps = (
  state,
  ownProps: { companyId?: string; sectionNumber?: number }
): Props => {
  const dividend = getDividendSectionSelector(state, ownProps);
  const viewMode = getViewMode(state);

  return {
    buybackYieldFormatted: dividend.buybackYieldFormatted,
    totalShareholderYieldFormatted: dividend.totalShareholderYieldFormatted,
    dividendPaymentsGrowthAnnualFormatted:
      dividend.dividendPaymentsGrowthAnnualFormatted,
    isFund: dividend.isFund,
    marketName: dividend.marketName,
    industryName: dividend.industryName,
    companyId: dividend.companyId,
    companyName: dividend.companyName,
    dividendNextDate: dividend.dividendNextDate,
    dividendNextDateFormatted: dividend.dividendNextDateFormatted,
    dividendNextPayDate: dividend.dividendNextPayDate,
    dividendNextPayDateFormatted: dividend.dividendNextPayDateFormatted,
    sectionNumber: ownProps.sectionNumber,
    showUpcomingDividendPayment: dividend.showUpcomingDividendPayment,
    dividendYield: dividend.dividendYield,
    dividendYieldFuture: dividend.dividendYieldFuture,
    dividendYieldFuture3Y: dividend.dividendYieldFuture3Y,
    marketDividendYieldP25: dividend.marketDividendYieldP25,
    marketDividendYieldP75: dividend.marketDividendYieldP75,
    industryDividendYield: dividend.industryDividendYield,
    dividendYieldFormatted: dividend.dividendYieldFormatted,
    marketDividendYieldP25Formatted: dividend.marketDividendYieldP25Formatted,
    marketDividendYieldP75Formatted: dividend.marketDividendYieldP75Formatted,
    industryDividendYieldFormatted: dividend.industryDividendYieldFormatted,
    dividendYieldFutureFormatted: dividend.dividendYieldFutureFormatted,
    dividendYieldFuture3YFormatted: dividend.dividendYieldFuture3YFormatted,
    currentDividendPayout: dividend.currentDividendPayout,
    currentDividendPayoutRatio: dividend.currentDividendPayoutRatio,
    currentDividendPayoutRatioFormatted:
      dividend.currentDividendPayoutRatioFormatted,
    futureDividendPayout: dividend.futureDividendPayout,
    futureDividendPayoutRatio: dividend.futureDividendPayoutRatio,
    futureDividendPayoutRatioFormatted:
      dividend.futureDividendPayoutRatioFormatted,
    cashDividendPayout: dividend.cashDividendPayout,
    cashDividendPayoutRatio: dividend.cashDividendPayoutRatio,
    cashDividendPayoutRatioFormatted: dividend.cashDividendPayoutRatioFormatted,
    lastPaymentDividendCurrency: dividend.lastPaymentDividendCurrency,
    tradingItemCurrencyISO: dividend.tradingItemCurrencyISO,
    viewMode,
  };
};

export default connect(mapStateToProps, null, null, {
  areStatesEqual: areStatesEqualCompanySection,
})(Dividend);
